
import { GeoLocation } from './common';

export enum EnumProductTypes {
  expired = "expired",
  oldexpired = "oldexpired",
  preforeclosure = "preforeclosure",
  distressed = "distressed",
  fsbo = "fsbo",
  customupload = "customupload",
  ns = "ns",
}

export type Note = {
  id: string;
  note: string;
  updatedAt: string;
  createdAt: string;
  formattedUpdatedAt: string;
  formattedCreatedAt: string;
};

export type Tag = string;

export interface Property {
  city: string;
  street_direction: string;
  building_number: string | null;
  house_number: string;
  street_name: string;
  geolocation: GeoLocation | null;
  floor_number: string | null;
  street_suffix: string;
  unit_number: string;
  county: string;
  state: string;
  postal_code: string;
  apartment_number: string | null;
  postal_code_plus4: string;
  id: number;
  street_address: string;
}


export type Socials = {
  facebook?: string;
  twitter?: string;
  instagram?: string;
  linkedin?: string;
};

export type Address = {
  streetAddress: string;
  city: string;
  state: string;
  postalCode: string;
  formattedAddress: string;
  // Granular fields for detailed address components
  houseNumber?: string;
  streetName?: string;
  streetSuffix?: string;
  streetPreDirection?: string;
  streetPostDirection?: string;
  postalCodePlus4?: string;
  unit?: string;
};

export type ContactInfo = {
  id: string;
  fullName: string;
  firstName: string;
  lastName: string;
  phone: string;
  formattedPhone: string;
  dnc?: boolean;
  phoneType: string;
  isFavorite?: boolean;
  hidden?: boolean;
  email?: string;
  listingId?: string;
};

export type OwnerContactInfo = {
  id?: string;
  fullName: string;
  firstName: string;
  lastName: string;
  phoneType?: string;
  address?: Address;
  socials?: Socials;
  email?: string;
  phone?: string;
  formattedPhone?: string;
  isFavorite?: boolean;
};

export interface SummaryListing {
  id: string;
  geolocation?: GeoLocation;
  productType: EnumProductTypes;
}

export interface Listing {
  geolocation?: GeoLocation;
  address: Address;
  productType: EnumProductTypes;
  id: string;
  propertyId: string;
  isFavorite?: boolean;
  title: string;
  beds: number;
  bath: number;
  sqrFeet: number;
  formattedSqrFeet: string;
  lotSize: string;
  formattedLotSize: string;
  yearBuilt: string;
  type: string;
  typeCode: string;
  status?: string;
  statusCode?: string;
  hasDom?: boolean;
  mapLink?: string | null | undefined;
  price?: number;
  formattedPrice?: string | number | null | undefined;
  dom?: number | string;
  notes: Note[];
  tags: Tag[];
  publishDate?: string;
  formattedPublishDate?: string;
  auctionDate?: string;
  formattedAuctionDate?: string;
  ownerContactInfo: OwnerContactInfo;
  contacts?: ContactInfo[];
  // Expireds
  taxId?: string;
  ownerOccupied?: boolean;
  mlsNumber?: string;
  listAgent?: string;
  listAgentPhone?: string;
  formattedListAgentPhone?: string;
  listAgentCompany?: string;
  statusDate?: string;
  formattedStatusDate?: string;
  daysOnMarket?: number;
  showingInstructions?: string;
  comments?: string;
  // FSBO
  adText?: string;
  publishId?: string;
  // Distressed
  distressedLevel?: string;
  isDistressed?: boolean;
  // Custom Upload
  extraFields?: string;
  // Preforeclosure
  mortgageHolder?: string;
  loanAmount?: string;
  formattedLoanAmount?: string;
  countyRecorded?: string;
  attorneyName?: string;
  attorneyPhone?: string;
  formattedAttorneyPhone?: string;
  mortgageDate?: string;
  formattedMortgageDate?: string;
  delinquentAmount?: number;
  formattedDelinquentAmount?: string;
  delinquentDate?: string;
  formattedDelinquentDate?: string;
  dateRecorded?: string;
  formattedDateRecorded?: string;
  trusteeSaleNumber?: string;
  auctionLocation?: string;
  auctionMinimumBid?: number;
  formattedAuctionMinimumBid?: string;
  demographics?: {
    age?: number;
    income?: number;
    occupation?: string;
    education?: string;
    gender?: string;
    maritalStatus?: string;
    numberOfChildren?: number;
    homeValueRange?: {
      start: number;
      end: number;
    };
    netWorth?: number;
    businessOwner?: boolean;
  };
}
